// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900);"]);
exports.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css);"]);
exports.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css);"]);
// Module
exports.push([module.id, ".v-application .primary{background-color:#1976d2!important;border-color:#1976d2!important}.v-application .primary--text{color:#1976d2!important;caret-color:#1976d2!important}", ""]);
// Exports
module.exports = exports;
